
export default class BasicInfoModel {
    constructor({request}) {
        this.request = request;
    }

    async getBasicInfo(fields) {
        return this.request.fetch('natasha/GET/BasicBxService/getBasicInfo', {fields, isBasic: true});
    }
    // UC账号是否有广告资质
    async isUCLicence() {
        return this.request.fetch('zebra/Post/UcService/queryUserHasLicence');
    }
    // 任务中心悬浮窗信息获取
     async getTaskCenterInfo(params) {
        const data = await this.request.fetch('natasha/Post/TaskCenterService/taskCentreFloatingWindow', params, {
            noErrorTip: true
        });
        return data?.respList || [];
    }

    // 新的查询视频合成任务列表
    async queryTasksV2(params) {
        const {pageNum, pageSize, taskId, productLine, queryDraft, renderType,
            source, videoName, dateRange, status} = params;
        const requestData = {
            page: {pageNum, pageSize}
        };
        if (productLine) {
            requestData.productLine = productLine;
        }
        let predicates = [];
        // 视频类型
        if (renderType !== undefined) {
            const values = Array.isArray(renderType) ? renderType : [renderType];
            predicates.push({
                field: 'renderType',
                operator: 'in',
                values
            });
        }

        if (source) {
            const values = Array.isArray(source) ? source : [source];
            predicates.push({
                field: 'source',
                operator: 'in',
                values
            });
        }

        // 任务ID或名称
        if (videoName !== undefined) {
            predicates.push({
                field: 'videoName',
                operator: 'eq',
                value: videoName
            });
        }

        // 日期筛选
        if (dateRange && dateRange.length === 2) {
            predicates.push({
                field: 'createTime',
                operator: 'ge',
                values: [dateRange[0]]
            });
            predicates.push({
                field: 'createTime',
                operator: 'le',
                values: [dateRange[1]]
            });
        }
        // 状态筛选
        if (status !== undefined && status !== 0) {
            if (status === 1) {
                predicates.push({
                    field: 'status',
                    operator: 'in',
                    values: [1, 4]
                });
            }
            else {
                predicates.push({
                    field: 'status',
                    operator: 'eq',
                    value: status
                });
            }
        }


        if (Array.isArray(taskId)) {
            predicates.push({
                field: 'taskId',
                operator: 'in',
                values: taskId
            });
        }
        if (typeof queryDraft === 'boolean') {
            requestData.queryDraft = queryDraft;
        }
        if (predicates.length) {
            requestData.predicates = predicates;
        }
        const listData = await this.request.fetch('zebra/POST/DigitalHumanService/queryTasksV2', requestData);
        // listData.items = listData.items.map(item => this.normalizeListItem(item));
        return listData;
    }
}
